import React from 'react'
import {Link} from 'react-router-dom'
import s from '../css/about.module.css'
/* const tecno = require.context('../image/tenologias/', true); */
import aboutimage from './AboutImage';  
import perritos from '../image/perritos.png'

export default function About() {
  return (
  <div className={s.conten1}>
     <img className={s.perritos} src={perritos} />
     <img className={s.perritos2} src={perritos} />  
    <div className={s.conten2}>
        <h2>Acerca de esta página</h2>
        <p>Esta aplicacion es un Proyecto Individual que sirvio para finalizar el
          curso de un Bootcamp para ser Full Stack Developer.</p>
        <p>Aquí encontraras información sobre las razas de perros existentes, a 
          que grupo pertenecen, su altura, su peso, y su temperamento.
        </p>
        <p> Este Proyecto se creo basado en ciertos criterios solicitados en un readme del proyecto :</p>
    </div>    
      <ul className={s.lista}>
        <li>Usar la API <a className={s.link} href='https://api.thedogapi.com/v1/breeds'>The Dog API.</a> Nota: solo este Endpoind </li>
        <li>Utilizar pate de la información y guardarla en la Base de Datos</li>
        <li>Crear una propia API con información seleccionada</li>
        <li>Filtrar por nombre, peso, temperamento, si la data es de la API o proviene de la BD</li>
        <li>Mostrar detalles de cada raza</li>
        <li>Opcion de Search Bar</li>
        <li>Crear un nuevo elemento (una nueva raza)</li>
      </ul>
   
    <div className={s.conten3}>
      <h2>Tecnologias utilizadas</h2>{/* tr fila td columna*/}
      <table>
        <tr>
          <td><img className={s.image} src={aboutimage.html5}/></td> {/* <img src={tecno(`./html5.png`)}/> */}
          <td><img className={s.image} src={aboutimage.css3}/></td>
          <td><img className={s.image2} src={aboutimage.react}/></td>
          <td><img className={s.image2} src={aboutimage.redux}/></td>
          <td><img className={s.image3} src={aboutimage.nodejs}/></td>
          <td><img className={s.image3} src={aboutimage.expressjs}/></td>
          <td><img className={s.image2} src={aboutimage.sequelize}/></td>
          <td><img className={s.image2} src={aboutimage.postgresql}/></td>
        </tr>
        <tr>
          <td>HTML5</td>
          <td>CSS3</td>
          <td>React</td>
          <td>Redux</td>
          <td>NodeJs</td>
          <td>expressJs</td>
          <td>Sequelize</td>
          <td>PostgreSQL</td>
        </tr>
      </table>
    </div>
    <div className={s.conten4}>
      <h2>Sobre mí</h2>
      <p> Hola</p>
      <p> Soy Alfonso Rosas C. un apasionado de la programacion y las nuevas 
          tecnologias.</p>
      <p>Para cualquier comentario, no dude en ponerse en contacto con migo ;.)</p>
      <img className={s.ico} src={aboutimage.linkedin}/><a className={s.link} href={'https://www.linkedin.com/in/jose-alfonso-rosas-caama%C3%B1o-1a142399/'}>Mi Linkedin</a>
      <br></br>
      <br></br>
      <img className={s.ico} src={aboutimage.github}/><a className={s.link} href={'#'}>Repositorio Github</a>
    </div>

    <div>
      <Link to='/home'>
        <button className={s.btn3}>Return</button>
      </Link>      
    </div>
  </div>  
  )
}
